
import React from 'react';
import Viewer from './Viewer';
import PageIntro from '../components/PageIntro';

export default function Docs() {
	return (
		<div style={{ maxWidth: 980, padding: 16 }}>
			<h1>Action Planning — Documentation</h1>

			<PageIntro
				title={`Action Planning — Business Guide`}
				description={`Executive summary and business rules for Action Planning. Use this section to understand journeys, roles, and expected behavior without implementation details.`}
				bullets={[
					'Executive summary: coordinates report generation, planning events, and monitoring.',
					'Who this is for: product managers and stakeholders who need high-level rules.',
					'What to expect next: review campaign flows, timelines and scheduling guidance.'
				]}
			/>

			<div style={{ border: '1px solid #eee', padding: 12 }}>
				<Viewer />
			</div>
		</div>
	);
}
